import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
    selector: 'wci-services',
    imports: [ButtonComponent],
    templateUrl: './services.component.html',
    styles: ``,
})
export class ServicesComponent {}
